<div class="w-full max-w-[800px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #dbeafe; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #2563eb; font-size: 24px; width: 24px; height: 24px;">history</mat-icon>
    </div>
    <div>
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Detalle de Conexiones</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">Historial de conexiones del d&iacute;a</p>
    </div>
  </div>

  <!-- User info card -->
  <div style="margin: 16px 24px; padding: 16px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px;">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Usuario (ID)</span>
        <span style="color: #111827; font-weight: 600; font-size: 0.9rem;">
          {{ record.nombre }} {{ record.apellidos }}
          <span style="color: #6b7280; font-size: 0.75rem;">({{ record.userId }})</span>
        </span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Email</span>
        <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ record.email }}</span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Tipo</span>
        <span style="font-weight: 700; font-size: 0.85rem; padding: 2px 10px; border-radius: 20px;"
          [style.color]="getUserTypeBadge().color"
          [style.background]="getUserTypeBadge().color + '18'">
          {{ getUserTypeBadge().label }}
        </span>
      </div>
      <div>
        <span style="color: #6b7280; font-size: 0.75rem; display: block;">Total Conexiones</span>
        <span style="color: #1C593D; font-weight: 700; font-size: 1.1rem;">{{ record.connectionCount }}</span>
      </div>

      <!-- Session info -->
      <div style="grid-column: 1 / -1; padding-top: 8px; border-top: 1px solid #bbf7d0;">
        <div class="flex flex-wrap gap-6">
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Fecha</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ formatDate(record.date) }}</span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">Primera Conexi&oacute;n</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ formatTime(record.firstConnectionAt) }}</span>
          </div>
          <div>
            <span style="color: #6b7280; font-size: 0.75rem; display: block;">&Uacute;ltima Conexi&oacute;n</span>
            <span style="color: #111827; font-weight: 500; font-size: 0.85rem;">{{ formatTime(record.lastConnectionAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Connection details list -->
  <div style="margin: 0 24px 16px; padding: 16px; background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px;"
    *ngIf="record.connectionDetails?.length">
    <h3 style="margin: 0 0 12px 0; font-size: 0.85rem; font-weight: 700; color: #374151; display: flex; align-items: center; gap: 6px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">devices</mat-icon>
      Detalle de Conexiones ({{ record.connectionDetails.length }})
    </h3>
    <div class="space-y-2">
      <div *ngFor="let conn of record.connectionDetails"
        style="display: flex; align-items: center; gap: 10px; padding: 10px 12px; background: white; border: 1px solid #e5e7eb; border-radius: 8px; flex-wrap: wrap;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #6b7280;">{{ getDeviceIcon(conn.deviceType) }}</mat-icon>
        <div style="flex: 1; min-width: 150px;">
          <span style="color: #111827; font-weight: 600; font-size: 0.8rem;">{{ conn.browser }} &middot; {{ conn.os }}</span>
          <div style="display: flex; gap: 8px; margin-top: 2px;">
            <span style="color: #6b7280; font-size: 0.7rem;">{{ conn.ip }}</span>
            <span style="color: #9ca3af; font-size: 0.7rem;">{{ conn.country }}</span>
          </div>
        </div>
        <span style="color: #6b7280; font-size: 0.75rem; font-weight: 500;">{{ formatTime(conn.connectedAt) }}</span>
      </div>
    </div>
  </div>

  <!-- No details -->
  <div *ngIf="!record.connectionDetails?.length"
    style="margin: 0 24px 16px; padding: 24px; text-align: center; color: #9ca3af;">
    <mat-icon style="font-size: 32px; width: 32px; height: 32px; color: #d1d5db;">info</mat-icon>
    <p style="margin: 8px 0 0 0; font-size: 0.85rem;">Sin detalles de conexi&oacute;n disponibles</p>
  </div>

  <!-- Close button -->
  <div style="display: flex; gap: 12px; padding: 20px 24px; border-top: 1px solid #e5e7eb; justify-content: flex-end;">
    <button (click)="close()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      Cerrar
    </button>
  </div>

</div>
